import { MockUser } from './environment.types';

export type { MockUser };

export const MOCK_USERS: Record<string, MockUser> = {
  default: {
    email: 'test@doe-test.nl',
    name: 'Test User',
    roles: ['APPBHR', 'FBH', 'TEBH'],
  },
  appbhr: {
    email: 'appbhr@doe-test.nl',
    name: 'App Beheerder',
    roles: ['APPBHR'],
  },
  fbh: {
    email: 'fbh@doe-test.nl',
    name: 'Functioneel Beheerder',
    roles: ['FBH'],
  },
  tebh: {
    email: 'tebh@doe-test.nl',
    name: 'Technisch Beheerder',
    roles: ['TEBH'],
  },
};
